export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

type WithResolversResult = {
  promise: Promise<void>
  resolve: () => void
  reject: () => void
}

/**
 * Drop-in replacement for Promise.withResolvers as it's too recent to be available in all browsers.
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/withResolvers
 */
export function withResolvers(): WithResolversResult {
  let resolve: () => void = () => {}
  let reject: () => void = () => {}

  const promise = new Promise<void>((res, rej) => {
    resolve = res
    reject = rej
  })

  return {
    promise,
    resolve,
    reject,
  }
}
